import {
  mdiRefresh,
  mdiPlus,
  mdiPencil,
  mdiTrayArrowDown,
  mdiHistory,
  mdiMenuDown,
  mdiMenuUp,
} from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import EntityHistory, {
  GetMasterLogsByEntityApi,
} from "../../purchase_order/purchase_order_create/components/entity_logs";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import { fetchGet, toQueryString } from "../../../service/api_client";
import { urls } from "../../../utils/urls";
import Pagination from "../../../ui/new_components/common/pagination";
import { debounce } from "lodash";
import moment from "moment";
import { ACTION, MODULE } from "../../../utils/enums";
import { useAuth } from "../../../context_providers/auth/authProvider";
import {
  customer_status,
  CustomerType,
  LeadSegment,
  UserModel,
} from "../../../context_providers/auth/user_model";
import FilterDropDown from "../../../ui/new_components/common/filter_drop_down";

interface CustomerListScreenProps {}

export interface CustomerFilterData {
  from?: Date;
  to?: Date;
  page: number;
  count: number;
  isEmp: boolean;
  search?: string;
  all?: any;
  city?: string;
  state?: string;
  status?: string[];
  lead_segment?: string[];
  customer_name?: string;
  customer_type?: string[];
  customer_group?: string;
  customer_id?: string;
  customer_phone?: string;
  gst_number?: string;
}

const defaultFilter: CustomerFilterData = {
  page: 1,
  count: 100,
  isEmp: false,
};

const CustomerListScreen: FunctionComponent<CustomerListScreenProps> = () => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/users/customer`;
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState<CustomerFilterData>(defaultFilter);
  const [updateDisabled, setUpdateDisabled] = useState(true);
  const [selected, setSelected] = useState<UserModel[]>([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(50);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<UserModel[]>([]);
  const [search, setSearch] = useState("");
  const [showHistory, setShowHistory] = useState<any>();
  const { isAuthorised } = useAuth();
  const [maker, setMaker] = useState(false);
  const [filterCollapsed, setFilterCollapsed] = useState(true);

  useEffect(() => {
    const disable = selected.length === 0;

    setUpdateDisabled(disable);
  }, [selected]);

  useEffect(() => {
    const authorised = isAuthorised({
      action: [ACTION.UPDATE, ACTION.CREATE, ACTION.READ],
      module: MODULE.customer_master,
    });
    setMaker(authorised);
  }, []);

  const fetchData = async (prop: CustomerFilterData) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setData(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const getCustomerExport = async () => {
    try {
      const a = document.createElement("a");
      a.target = "_blank";
      a.href = `${
        process.env.REACT_APP_BACKEND_BASE_URL
      }/api/v3/users/customer/export${toQueryString({
        query: JSON.stringify({
          ...filter,
        }),
      })}`;

      // Delay the trigger to allow UI updates (if necessary)
      setTimeout(() => {
        setLoading(false);
        showToast({ type: ToastType.success, text: "Download started!" });
        a.click(); // Trigger the download
      }, 1000);
    } catch (error) {
      setLoading(false); // Make sure loading is set to false in case of an error
      showToast({ type: ToastType.error, text: "Failed to start download." });
      console.error("Download error:", error);
    }
  };

  const debouncedHandler = useCallback(
    debounce((prop: CustomerFilterData) => {
      if (prop) fetchData(prop);
    }, 500),
    [],
  );

  useEffect(() => {
    debouncedHandler(filter);
  }, [page, filter, debouncedHandler]);

  useEffect(() => {
    if (count) fetchData({ page, count, search, isEmp: false });
  }, [count]);

  const navaigation = useHistory();

  const handleOnEdit = () => {
    if (selected.length > 1) {
      showToast({
        type: ToastType.error,
        text: "Please select one item to edit",
      });
    } else if (selected.length === 0) {
      showToast({
        type: ToastType.error,
        text: "Please select an item to edit",
      });
    } else {
      navaigation.push(urls.customer_master + "/update/" + selected[0]!.uid);
    }
  };

  return (
    <>
      {showHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="Customer History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetMasterLogsByEntityApi({
                entityType: "customer",
                entityId: showHistory,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}

      <div
        id="page_container"
        className="flex flex-col justify-between h-[100dvh] overflow-hidden p-2 md:p-1"
      >
        <section
          id="top_section"
          className="flex flex-col gap-2 justify-start items-start md:flex-row md:justify-between md:items-end my-1 md:gap-0"
        >
          <h1 className="font-bold text-lg md:text-2xl text-gray-500 border-l-4 border-myPrimaryColor pl-2 flex items-center md:items-start md:justify-start gap-3  flex-nowrap whitespace-nowrap">
            Customer Master
            <button
              title="Refersh"
              onClick={() => fetchData({ page, count, search, isEmp: false })}
            >
              <Icon path={mdiRefresh} className="h-6 w-6"></Icon>
            </button>
          </h1>

          <div className="flex flex-col md:flex-row xl:items-center xl:gap-4 w-full xl:justify-end mt-3 xl:mt-0 text-sm gap-2 ">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:flex md:flex-row gap-2 mt-2 md:mt-0 items-center">
              <button
                onClick={() => {
                  navaigation.push(urls.customer_master + "/create");
                }}
                className="flex gap-1 justify-center items-center cursor-pointer rounded-md px-3 py-1 bg-myPrimaryColor text-white transition-all duration-200 md:hover:brightness-90"
              >
                <Icon path={mdiPlus} className="h-4 w-4"></Icon>Create
              </button>

              <button
                onClick={() => {
                  // setShowExport(true);
                  getCustomerExport();
                }}
                className="rounded-md border px-3 py-1 transition-all duration-200 md:hover:bg-gray-800 md:hover:text-white flex gap-1 justify-center items-center"
              >
                <Icon path={mdiTrayArrowDown} className="h-4 w-4"></Icon>
                Export
              </button>
              {maker && (
                <button
                  disabled={updateDisabled}
                  onClick={() => {
                    handleOnEdit();
                  }}
                  className={`${
                    updateDisabled
                      ? "cursor-not-allowed  text-gray-300"
                      : "md:hover:bg-black md:hover:text-white"
                  } flex gap-1 justify-center items-center border rounded-md px-3 py-1 transition-all duration-200`}
                >
                  <Icon path={mdiPencil} className="h-4 w-4 "></Icon>Update
                </button>
              )}
            </div>
          </div>
        </section>

        <div className="flex items-center gap-2 mt-1 md:hidden">
          <h6 className="text-sm font-medium text-gray-600">Filters</h6>
          <button
            onClick={() => setFilterCollapsed((o) => !o)}
            className="flex items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white"
          >
            <Icon
              path={filterCollapsed ? mdiMenuDown : mdiMenuUp}
              className="w-4 h-4"
            />
          </button>
        </div>

        <section
          className={`${
            filterCollapsed ? "hidden md:flex" : "flex"
          } items-start justify-start mt-2 md:m-4 rounded-lg border border-gray-300 shadow-sm bg-white p-3 md:border-0 md:shadow-none md:bg-transparent md:p-0`}
        >
          <div className="grid grid-cols-2 md:grid-cols-5 gap-2 md:gap-6 w-full text-xs md:text-sm">
            <div className="w-full">
              <label htmlFor="fromDate" className="">
                From
              </label>
              <input
                type="date"
                id="fromDate"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={
                  filter.from ? moment(filter?.from).format("YYYY-MM-DD") : ""
                }
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  const fromDate = selectedDate
                    ? new Date(new Date(selectedDate).setHours(0, 0, 0, 0))
                    : undefined;
                  setFilter({ ...filter, from: fromDate });
                }}
              />
            </div>
            <div className="w-full">
              <label htmlFor="todate" className="">
                To
              </label>
              <input
                type="date"
                id="todate"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter.to ? moment(filter?.to).format("YYYY-MM-DD") : ""}
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  const toDate = selectedDate
                    ? new Date(new Date(selectedDate).setHours(0, 0, 0, 0))
                    : undefined;
                  setFilter({ ...filter, to: toDate });
                }}
              />
            </div>
            <div className="w-full rounded focus:outline-none">
              <label htmlFor="id" className="">
                Customer ID
              </label>
              <input
                type="text"
                id="customer_id"
                placeholder="cutomer id"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter?.customer_id || ""}
                onChange={(e) => {
                  setFilter((prevFilter) => ({
                    ...prevFilter,
                    customer_id: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="w-full rounded focus:outline-none">
              <label htmlFor="app_status" className="">
                Customer Name
              </label>
              <input
                type="text"
                id="customer"
                placeholder="customer"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter?.customer_name || ""}
                onChange={(e) => {
                  setFilter((prevFilter) => ({
                    ...prevFilter,
                    customer_name: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="w-full rounded focus:outline-none">
              <label htmlFor="customer_phone" className="">
                Phone No.
              </label>
              <input
                type="text"
                inputMode="numeric"
                id="customer_phone"
                placeholder="phone no"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter?.customer_phone || ""}
                onChange={(e) => {
                  const digits = e.target.value.replace(/\D/g, "");
                  setFilter((prevFilter) => ({
                    ...prevFilter,
                    page: 1,
                    customer_phone: digits || undefined,
                  }));
                }}
              />
            </div>
            <div className="w-full rounded focus:outline-none">
              <label htmlFor="gst_number" className="">
                GST Number
              </label>
              <input
                type="text"
                id="gst_number"
                placeholder="gst number"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter?.gst_number || ""}
                onChange={(e) => {
                  setFilter((prevFilter) => ({
                    ...prevFilter,
                    page: 1,
                    gst_number: e.target.value || undefined,
                  }));
                }}
              />
            </div>
            <div className="">
              <label htmlFor="item_type" className="">
                Customer Type
              </label>
              <FilterDropDown
                placeholder="customer_type"
                onClearAll={() =>
                  setFilter({
                    ...filter,

                    customer_type: undefined,
                  })
                }
                onDelete={(type) => {
                  setFilter({
                    ...filter,

                    customer_type: filter?.customer_type?.filter(
                      (f) => f !== type,
                    ),
                  });
                }}
                onSelect={(type) => {
                  setFilter((old) => ({
                    ...old,

                    customer_type: [...(old?.customer_type ?? []), type],
                  }));
                }}
                selectedOptions={filter?.customer_type ?? []}
                options={Object.values(CustomerType).map((t) => ({
                  label: t,
                  value: t,
                }))}
              />
            </div>
            <div className="w-full rounded focus:outline-none">
              <label htmlFor="app_status" className="">
                Customer Group
              </label>
              <input
                type="text"
                id="customer_group"
                placeholder="customer_group"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter?.customer_group || ""}
                onChange={(e) => {
                  setFilter((prevFilter) => ({
                    ...prevFilter,
                    customer_group: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="">
              <label htmlFor="item_type" className="">
                Lead Segment
              </label>
              <FilterDropDown
                placeholder="lead_segment"
                onClearAll={() =>
                  setFilter({
                    ...filter,

                    lead_segment: undefined,
                  })
                }
                onDelete={(type) => {
                  setFilter({
                    ...filter,

                    lead_segment: filter?.lead_segment?.filter(
                      (f) => f !== type,
                    ),
                  });
                }}
                onSelect={(type) => {
                  setFilter((old) => ({
                    ...old,

                    lead_segment: [...(old?.lead_segment ?? []), type],
                  }));
                }}
                selectedOptions={filter?.lead_segment ?? []}
                options={Object.values(LeadSegment).map((t) => ({
                  label: t,
                  value: t,
                }))}
              />
            </div>
            <div className="">
              <label htmlFor="item_type" className="">
                Status
              </label>
              {/* <select
                  className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                  name="status"
                  id="status"
                  value={filter.status ?? ""}
                  onChange={(e) => {
                    setFilter((prevData) => ({
                      ...prevData,
                      status: e.target.value, // Directly updating type
                    }));
                    // setSelectedType(e.target.value);
                    // setSelected([]);
                  }}
                >
                  <option value="">select</option>
                  {Object.values(customer_status).map((f: string) => (
                    <option key={f} value={f}>
                      {f}
                    </option>
                  ))}
                </select> */}
              <div className=" ">
                <FilterDropDown
                  placeholder="Status"
                  onClearAll={() =>
                    setFilter({
                      ...filter,

                      status: undefined,
                    })
                  }
                  onDelete={(type) => {
                    setFilter({
                      ...filter,

                      status: filter?.status?.filter((f) => f !== type),
                    });
                  }}
                  onSelect={(type) => {
                    setFilter((old) => ({
                      ...old,

                      status: [...(old?.status ?? []), type],
                    }));
                  }}
                  selectedOptions={filter?.status ?? []}
                  options={Object.values(customer_status).map((t) => ({
                    label: t,
                    value: t,
                  }))}
                />
              </div>
            </div>
            <div className="">
              <label htmlFor="city" className="">
                City
              </label>
              <input
                type="text"
                id="city"
                placeholder="city"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter?.city || ""}
                onChange={(e) => {
                  setFilter((prevFilter) => ({
                    ...prevFilter,
                    city: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="">
              <label htmlFor="state" className="">
                State
              </label>
              <input
                type="text"
                id="state"
                placeholder="state"
                className="w-full border rounded h-8 px-2 bg-white focus:outline-none"
                value={filter?.state || ""}
                onChange={(e) => {
                  setFilter((prevFilter) => ({
                    ...prevFilter,
                    state: e.target.value,
                  }));
                }}
              />
            </div>
          </div>
        </section>

        {/* Mobile card list */}
        <div className="md:hidden my-2 overflow-y-auto flex-1 min-h-[40vh] flex flex-col gap-2 text-xs">
          {data.length > 0 ? (
            data.map((d, i) => (
              <div
                key={i}
                className="border rounded-lg bg-white p-3 shadow-sm flex flex-col gap-1"
              >
                <div className="flex items-center justify-between gap-2">
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={selected.some((v) => v.uid === d.uid)}
                      onChange={(e) => {
                        setSelected(
                          e.target.checked
                            ? [...selected, d]
                            : selected.filter((w) => w.uid !== d.uid),
                        );
                      }}
                    />
                    <a
                      href={`${urls.customer_master}/view/${d.uid}`}
                      className="text-blue-500 font-semibold"
                    >
                      {d.uid}
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">
                      {d.status || "--"}
                    </span>
                    <button
                      title="History"
                      onClick={() => setShowHistory(d.uid)}
                    >
                      <Icon path={mdiHistory} size={0.7}></Icon>
                    </button>
                  </div>
                </div>
                <div className="font-semibold text-sm break-words">
                  {d?.first_name ?? "--"}
                </div>
                <div className="grid grid-cols-2 gap-x-3 gap-y-1 text-gray-600">
                  <div className="col-span-2">
                    <span className="text-gray-400">Phone: </span>
                    {d.mobile || "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">Created: </span>
                    {moment(d?.created_at).format("DD-MM-YYYY")}
                  </div>
                  <div>
                    <span className="text-gray-400">Group: </span>
                    {d.additional_customer_details?.customer_group ?? "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">Type: </span>
                    {d.additional_customer_details?.customer_type ?? "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">Segment: </span>
                    {d.additional_customer_details?.lead_segment ?? "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">GST Reg: </span>
                    {d.gst_details?.gst_registration ?? "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">GST No: </span>
                    {d.gst_details?.gst_number ?? "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">Sales: </span>
                    {d.additional_customer_details?.sales_person ?? "--"}
                  </div>
                  <div className="col-span-2">
                    <span className="text-gray-400">RM: </span>
                    {d.additional_customer_details?.relationship_manager ??
                      "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">City: </span>
                    {d.registered_office_address?.city ?? "--"}
                  </div>
                  <div>
                    <span className="text-gray-400">State: </span>
                    {d.registered_office_address?.state ?? "--"}
                  </div>
                  <div className="col-span-2">
                    <span className="text-gray-400">Country: </span>
                    {d.registered_office_address?.country ?? "--"}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="h-40 flex items-center justify-center text-gray-400">
              No Data Found!
            </div>
          )}
        </div>

        <div className="hidden md:block my-2 border overflow-y-auto flex-1 min-h-[40vh] sm:min-h-0">
          <table className="w-full text-xs divide-y divide-gray-200 relative">
            <thead className="font-semibold py-2 sticky -top-1 bg-white z-10">
              <tr className="border text-left">
                <th className="px-3 py-3">
                  <div className="Select ">
                    <input
                      type="checkbox"
                      checked={selected.length === data.length}
                      onChange={(e) => {
                        setSelected(e.target.checked ? [...data] : []);
                      }}
                    />
                  </div>
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-center">
                  History
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Customer Id
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Created At
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Customer Name
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Phone No.
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Customer Group
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Cutsomer Type
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Lead Segment
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  GST Registration
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  GST Number
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Sales Person
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Relationship Manager
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">City</th>
                <th className="px-3 py-3 whitespace-nowrap text-left">State</th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Country
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((d, i) => (
                  <tr key={i} className="border text-left">
                    <td className="px-3 py-3">
                      <input
                        type="checkbox"
                        checked={selected.some((v) => v.uid === d.uid)}
                        onChange={(e) => {
                          setSelected(
                            e.target.checked
                              ? [...selected, d]
                              : selected.filter((w) => w.uid !== d.uid),
                          );
                        }}
                      />
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-center">
                      <div
                        className="cursor-pointer flex justify-center"
                        title="History"
                        onClick={() => setShowHistory(d.uid)}
                      >
                        <Icon path={mdiHistory} size="16"></Icon>
                      </div>
                    </td>
                    <td className="px-3 py-3 text-blue-500 whitespace-nowrap">
                      <a href={`${urls.customer_master}/view/${d.uid}`}>
                        {d.uid}
                      </a>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {moment(d?.created_at).format("DD-MM-YYYY")}
                    </td>
                    <td className="px-3 py-3 text-left">
                      {d?.first_name ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.mobile || "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.additional_customer_details?.customer_group ?? "---"}
                    </td>
                    <td className="px-3 py-3 ">
                      {d.additional_customer_details?.customer_type || "---"}
                    </td>
                    <td className="px-3 py-3 ">
                      {d.additional_customer_details?.lead_segment || "---"}
                    </td>
                    {/* <td className="px-3 py-3 ">{d.address?.line3 || "---"}</td> */}
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.gst_details?.gst_registration || "---"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.gst_details?.gst_number || "---"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.additional_customer_details?.sales_person || "---"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.additional_customer_details?.relationship_manager ||
                        "---"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.registered_office_address?.city || "---"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.registered_office_address?.state || "---"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.registered_office_address?.country || "---"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      {d.status || "---"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17} className="h-56 text-center p-5 my-20">
                    <h5 className="text-gray-400 text-2xl">No Data Found!</h5>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-3">
          <Pagination
            itemCount={data.length}
            page={filter.page}
            total={total}
            count={filter.count}
            onChange={(page) => setFilter((o) => ({ ...o, page }))}
          />
        </div>
      </div>

      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default CustomerListScreen;
